export default "__VITE_ASSET__B1pXZ$gK__"